module.exports = __webpack_public_path__ + "img/group-4.95918da4.jpg";